var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React from "react";
import styled from "styled-components";
import { compose, graphql, PageLayout, withGraphqlErrorFlags, withLoadingSpinner, withShowFlag, withServiceNotFoundHandler, GrayText, withFeatureFlags, FlexDiv, ReactRouter } from "@atlassiansox/microscopekit";
import EmptyState from "@atlaskit/empty-state";
import mapPlanning from "./us-map-planning.svg";
import serviceQuery from "./deployments-page.query.graphql";
import { Divider, capitalizeWord, updateURLParams } from "./utils";
import { ShardView } from "./shard-view";
import { DetailedDeploymentsPage } from "./detailed-deployments-page";
import ArrowLeftCircleIcon from '@atlaskit/icon/glyph/arrow-left-circle';
import { BuildSystems } from "./build-system-section/build-systems";
var Select = require("@atlaskit/select").default;
var _a = require("@atlaskit/page"), Grid = _a.Grid, GridColumn = _a.GridColumn;
var ViewSwitchDiv = styled(FlexDiv)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  font-size: 12pt;\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"], ["\n  align-items: center;\n  font-size: 12pt;\n  &:hover {\n    cursor: pointer;\n    text-decoration: underline;\n  }\n"])));
var ViewSwitchIcon = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 3px;\n  margin-right: 3px;\n"], ["\n  margin-top: 3px;\n  margin-right: 3px;\n"])));
export var DeploymentPageComponent = function (props) {
    var _a;
    var flags = props.flags;
    var _b = props.data, microsEnvironments = _b.microsEnvironments, service = _b.service;
    var _c = service, microsV2 = _c.microsV2, metadata = _c.metadata;
    var location = ReactRouter.useLocation();
    var history = ReactRouter.useHistory();
    var urlParams = new URLSearchParams(location.search);
    var label = urlParams.get("label");
    var env = urlParams.get("env");
    var region = urlParams.get("region");
    if (flags["microsPluginDetailedDeploymentsPage"] && urlParams.get("view") === "detailed") {
        return (React.createElement(PageLayout, { title: "Deployments", actions: React.createElement(ViewSwitchDiv, { onClick: function () {
                    history.push("" + location.pathname + updateURLParams(location.search, [
                        { name: "view", val: null },
                        { name: "tab", val: null },
                        { name: "envRegion", val: null },
                        { name: "type", val: null },
                        { name: "label", val: "all" },
                        { name: "env", val: "ALL" },
                        { name: "region", val: "all" }
                    ]));
                } },
                React.createElement(ViewSwitchIcon, null,
                    React.createElement(ArrowLeftCircleIcon, { label: "simplified-view-button" })),
                "Go to Simplified View") },
            React.createElement(DetailedDeploymentsPage, __assign({}, props))));
    }
    if (!label || !env || !region) {
        history.push(updateURLParams(location.search, [
            { name: "label", val: label || "all" },
            { name: "env", val: env || "ALL" },
            { name: "region", val: region || "all" }
        ]));
        return React.createElement(React.Fragment, null);
    }
    var labelFilter = label.toLowerCase();
    var regionFilter = region.toLowerCase();
    var envFilter = env.toUpperCase();
    var filterShards = function () {
        var microsEnvironments = props.data.microsEnvironments;
        if (!microsV2) {
            return [];
        }
        var defaultShards = microsV2.shards;
        var shards = labelFilter === "all"
            ? defaultShards
            : [defaultShards.find(function (s) { return s.label === labelFilter; })];
        var validRegions = regionFilter === "all"
            ? microsEnvironments
            : microsEnvironments.filter(function (e) { return e.region === regionFilter; });
        var validEnvs = (envFilter === "ALL"
            ? validRegions
            : validRegions.filter(function (e) { return e.type === envFilter.toUpperCase(); })).map(function (e) { return e.id; });
        return shards
            .filter(function (s) { var _a; return (_a = s === null || s === void 0 ? void 0 : s.environments) === null || _a === void 0 ? void 0 : _a.items; })
            .map(function (s) { return (__assign(__assign({}, s), { environments: __assign(__assign({}, s.environments), { items: s.environments.items.filter(function (e) {
                    return validEnvs.some(function (env) { return env === e.name; });
                }) }), __typename: s.__typename })); });
    };
    var filteredShards = filterShards();
    var shardOptions = __spreadArrays([
        { label: "Label: All", value: "all" }
    ], ((microsV2 === null || microsV2 === void 0 ? void 0 : microsV2.shards) || []).map(function (e) { return ({
        label: "Label: " + capitalizeWord(e.label),
        value: e.label,
    }); }));
    var environmentOptions = __spreadArrays([
        { label: "Env: All", value: "ALL" }
    ], Array.from(new Set(microsEnvironments.map(function (e) { return e.type; }))).map(function (e) { return ({
        label: "Env: " + capitalizeWord(e),
        value: e,
    }); }));
    var regionOptions = __spreadArrays([
        { label: "Region: All", value: "all" }
    ], Array.from(new Set(microsEnvironments.map(function (e) { return e.region; }))).map(function (e) { return ({ label: "Region: " + e, value: e }); }));
    var curShard = shardOptions.find(function (option) { return option.value === labelFilter; });
    var curEnv = environmentOptions.find(function (option) { return option.value === envFilter; });
    var curRegion = regionOptions.find(function (option) { return option.value === regionFilter; });
    if (!curShard || !curEnv || !curRegion) {
        history.push(updateURLParams(location.search, [
            { name: "label", val: (curShard === null || curShard === void 0 ? void 0 : curShard.value) || "all" },
            { name: "env", val: (curEnv === null || curEnv === void 0 ? void 0 : curEnv.value) || "ALL" },
            { name: "region", val: (curRegion === null || curRegion === void 0 ? void 0 : curRegion.value) || "all" }
        ]));
        return React.createElement(React.Fragment, null);
    }
    var serviceAdminUsers = metadata.admins
        .filter(function (m) { return m.__typename === "User"; })
        .map(function (m) { return m.username; });
    if (!microsV2) {
        return (React.createElement(PageLayout, { title: "Deployments" },
            React.createElement(GrayText, { bold: true }, props.id + " is not a Micros service.")));
    }
    return (React.createElement(PageLayout, { title: "Deployments" },
        flags["buildPlansUx"] && React.createElement(BuildSystems, { serviceId: props.id }),
        React.createElement(Grid, null,
            shardOptions.length > 2 && (React.createElement(GridColumn, { medium: 4 },
                React.createElement(Select, { id: "label-filter", options: shardOptions, value: curShard, onChange: function (_a) {
                        var value = _a.value;
                        return history.push(updateURLParams(location.search, [{ name: "label", val: value }]));
                    }, placeholder: "Label" }))),
            React.createElement(GridColumn, { medium: 4 },
                React.createElement(Select, { id: "env-filter", options: environmentOptions, value: curEnv, onChange: function (_a) {
                        var value = _a.value;
                        return history.push(updateURLParams(location.search, [{ name: "env", val: value }]));
                    }, placeholder: "Env" })),
            React.createElement(GridColumn, { medium: 4 },
                React.createElement(Select, { id: "region-filter", options: regionOptions, value: curRegion, onChange: function (_a) {
                        var value = _a.value;
                        return history.push(updateURLParams(location.search, [{ name: "region", val: value }]));
                    }, placeholder: "Region" }))),
        React.createElement(Divider, null),
        labelFilter &&
            envFilter &&
            regionFilter &&
            ((_a = filteredShards[0]) === null || _a === void 0 ? void 0 : _a.environments.items.length) !== 0 ? filteredShards.map(function (shard) { return (React.createElement(ShardView, { serviceName: service.id, hideShardInfo: shardOptions.length <= 2, microsEnvironments: microsEnvironments, shard: shard, serviceAdminUsers: serviceAdminUsers })); }) : React.createElement(EmptyState, { header: "No deployments found", description: "", imageUrl: mapPlanning, maxImageWidth: 800, maxImageHeight: 800 })));
};
export var DeploymentsPage = compose(graphql(serviceQuery), withFeatureFlags, withLoadingSpinner, withShowFlag, withGraphqlErrorFlags, withServiceNotFoundHandler)(DeploymentPageComponent);
var templateObject_1, templateObject_2;
